import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-about-us',
  templateUrl: './advertise-with-us.component.html',
  styleUrls: ['./advertise-with-us.component.scss']
})
export class AdvertiseWithUsComponent implements OnInit {

  constructor() {
    window.location.href = "https://wickedlist.com/b/contact-us/"
  }

  ngOnInit() {
  }
}
